import { Section } from '@/src/common/components/Section'
import { routerBack } from '@/src/common/utils/routerBack'
import { mesaColorNames } from '@/src/common/theme'
import { Redirect, Stack } from 'expo-router'
import { useCardStackScreenOld } from '@/src/app/main/(tabs)/card/card-management/_common/cardStackScreen'
import { useDismissToCardHome } from '@/src/app/main/(tabs)/card'
import { withCardGate } from '@/src/experiences/card-accounts/withCardGate'
import { Platform } from 'react-native'

export const viewingVirtualCardDisabled = Platform.OS === 'web'

export default function Layout() {
  // viewing the virtual card isn't allowed on web for Phase 1
  // but it will be in Phase 2
  // https://docs.google.com/document/d/1hoDz_wzIgLKIFIZ2Ili9WMHcIFpwAZthTA6SfuDtNWM/edit?tab=t.0#bookmark=id.wqur40getu90
  if (viewingVirtualCardDisabled) {
    return <Redirect href="/main/card" />
  }

  return <LayoutNav />
}

const LayoutNav = withCardGate(function LayoutNav({ showCardManagement, firstCardFetchFinished }) {
  const onClosePress = useDismissToCardHome({ showCardManagement, firstCardFetchFinished })

  return (
    <Stack>
      {useCardStackScreenOld({
        name: 'index',
        options: {
          title: 'Your Mesa Homeowners Card',
          headerShown: true,
          contentStyle: {
            paddingHorizontal: 0,
            backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'],
          },
        },
        sectionProps: { onClosePress },
      })}

      <Stack.Screen
        name="activateCard"
        options={{
          presentation: 'modal',
          contentStyle: { backgroundColor: mesaColorNames['Primary/Light #F7F9FB'] },
          headerShown: true,
          header() {
            return (
              <Section
                title="Activate Card"
                style={{ backgroundColor: mesaColorNames['Mesa - Brand/Secondary #223843'] }}
                headerStyle={{ height: 'auto', marginBottom: 0, padding: 24 }}
                titleStyles={{ color: mesaColorNames['Mesa - Brand/White #FFFFFF'] }}
                onBackPress={() => void routerBack()}
                chevronColor={mesaColorNames['Mesa - Brand/White #FFFFFF']}
              />
            )
          },
        }}
      />
      <Stack.Screen
        name="freeze"
        options={{
          presentation: 'formSheet',
          gestureDirection: 'vertical',
          animation: 'slide_from_bottom',
          sheetGrabberVisible: false,
          sheetInitialDetentIndex: 0,
          sheetAllowedDetents: 'fitToContents',
          contentStyle: { backgroundColor: mesaColorNames['Mesa - Brand/White #FFFFFF'] },
          headerShown: true,
        }}
      />
    </Stack>
  )
})
